import { BaseCoreGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/BaseCoreGameCommunicationProcessor';
import { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';
import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '@pp/core/src/logger/RoundIntegrityWatcher';
import { fetchUserInfoAction } from '@pp/core/src/store/apiActions/fetchUserInfoAction';
import { CoreStoreType } from '@pp/core/src/store/CoreStore';
import { chipActions } from '@pp/core/src/store/slices/chips/slice';
import { ChipSelectionOrigin, ChipValueType } from '@pp/core/src/store/slices/chips/types';
import { gameStateActions } from '@pp/core/src/store/slices/game/slice';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

import { GameStore } from '../../../store/GameStore';
import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';

export class GameComunicationStartDealingProcessor extends BaseCoreGameCommunicationProcessor {
  delay = 0;
  messageName = 'startDealing';
  private lastDispatchedChip: ChipValueType | null = null;

  process(message: GameCommunicationMessageType, store: GameStore): void {
    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.StartDealing);

    const session = store.getState().config.session;
    const JSESSIONID = session?.JSESSIONID;
    const baseUrl = session?.metaServer;

    if (JSESSIONID && baseUrl) {
      store.dispatch(fetchUserInfoAction({ JSESSIONID, baseUrl, force: true, essential: true }));
    }

    this.saveLastChip(store);
    setTimeout(() => {
      this.setDealingStatus(store);
    }, 100);
  }

  protected saveLastChip(store: CoreStoreType): void {
    const selectedChip = store.getState().chips.selectedChip;

    // Save initially selected chip on server after betting phase is over.
    if (!this.lastDispatchedChip && selectedChip && selectedChip.selectedBy === ChipSelectionOrigin.System) {
      store.dispatch(chipActions.setAndSyncSelectedChip(selectedChip));
      this.lastDispatchedChip = selectedChip;
    }

    // Save system selected chip on server after betting phase is over.
    if (
      this.lastDispatchedChip &&
      selectedChip &&
      selectedChip.selectedBy === ChipSelectionOrigin.System &&
      selectedChip.weight !== this.lastDispatchedChip?.weight
    ) {
      store.dispatch(chipActions.setAndSyncSelectedChip(selectedChip));
      this.lastDispatchedChip = selectedChip;
    }
  }

  protected setDealingStatus(store: CoreStoreType): void {
    const betStack = store.getState().bets.betStack;
    const totalBet =
      betStack.length > 0
        ? Object.values(betStack[betStack.length - 1]?.betSpots).reduce((sum, { value }) => sum + value, 0)
        : 0;
    store.dispatch(highflyerStateActions.setMultiplier(1));
    if (totalBet > 0) {
      store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.Dealing));
    } else {
      store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.WaitForNextGame));
    }
  }
}
